const PARAGRAPH_MARGIN_CALCULATOR = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    id
    title
    ... on MarginCalculator {
      id
      heading
      bookmakerLabel
      clearButtonLabel
      definition
      fairLabel
      introduction
      linksHeading
      marginLabel
      marketTypeOptions
      marketTypesLabel
      numberOfSelectionsHelpText
      numberOfSelectionsLabel
      numberOfSelectionsPlaceholder
      numberOfSelectionsRestrictionText
      oddsFormatLabel
      oddsFormatOptions
      oddsLabel
      oddsPlaceholder
      optionOddsLabel
      optionOddsPlaceholder
      payoutLabel
      probabilityLabel
      title
      type
      uuid
      otherTools {
        toolIcon
        toolLink
        toolTitle
      }
    }
  }
`;

export default PARAGRAPH_MARGIN_CALCULATOR;
